let whiteListedVariants = ["01", "04", "08"];

export default class DeviceValidator {
  constructor(logger)
  {
    this.logger = logger;
  }

  isValidDevice(device){
    let variantNr = device.variant.substring(0, 2);
    if (device.deviceConnection !== "USB" || !whiteListedVariants.includes(variantNr)) {
      this.logger.info("Jabra device is not the right kind of device or not plugged in via USB.");
      return false;
    }

    return true;
  }
}
